import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentParking } from 'projects/Administration/src/app/business-entities/dealer-parking-model';
import { DwoDocumentsBusinessService } from 'projects/Administration/src/app/business-services/dwo-documents.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';


export class AppModalContentComponent {
  constructor(public activeModal: NgbActiveModal) { }
}

@Component({
  selector: 'app-appointment-parking',
  templateUrl: './appointment-parking.component.html',
  styleUrls: ['./appointment-parking.component.css']
})
export class AppointmentParkingComponent implements OnInit {
  response: AppointmentParking
  url: string;
  closeResult: string;
  isParkingImageAvailable: boolean = false;
  @ViewChild('content') content;
  constructor(
    private service: DwoDocumentsBusinessService,
    private readonly editAppointmentService: EditAppointmentService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private activeModal : NgbActiveModal
  ) { }
 

  ngOnInit(): void {
    this.getParkingImage()
  }
  getParkingImage() {
    this.spinner.show()
    this.service.getAppointmentParkingImage(this.editAppointmentService.appointmentDetails.appointmentGuid).then((res) => {
      if(res.responseObject.imagePath == undefined){
        this.isParkingImageAvailable = false;
      }
      else{
        this.isParkingImageAvailable = true;
        this.response = res.responseObject
        this.url = this.response.imagePath;
      }
      
    })
    
    this.spinner.hide()
  }
 
  openModal(){
    this.modalService.open(this.content, { centered: true,size:'xl' });
  }
  
OnClose(){
  this.activeModal.close({success: false});
  }
}
